<form autocomplete="off" (click)="open()" [class.expanded]="showDrawer$ | async">
  <mat-form-field class="search" appearance="fill" spellcheck="false">
    <input [formControl]="input" #searchInput="matInput" matInput placeholder="Search patient">
    <mat-icon matPrefix>search</mat-icon>
    <button *ngIf="input.value" class="clear-button" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="input.reset()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</form>
<div class="mat-drawer-container mat-drawer-transition">
  <div class="mat-drawer-backdrop" [class.mat-drawer-shown]="showDrawer$ | async" (click)="close()"></div>
  <div class="mat-drawer" [class.mat-drawer-shown]="showDrawer$ | async">
    <mat-toolbar>
      <button mat-icon-button (click)="close()">
        <mat-icon>arrow_back</mat-icon>
      </button>
    </mat-toolbar>
    <app-patients-list [filters]="input.value" (click)="showDrawer$.next(false)"></app-patients-list>
    <!-- <app-patients [filters]="input.value" (click)="showDrawer$.next(false)"></app-patients> -->
  </div>
</div>